import React from "react";

function ViewCategory({ data }) {

  return (
    <div className="custom-modal-body">
      <div className="model-custum">
        <div className="mb-3">
          <img
            src={`http://localhost:5000/uploads/product/${data?.image}`}
            alt="category"
            style={{
              width: "100px",
              borderRadius: "10px"
            }}
          />
        </div>
        <h3>
          {data?.name}
        </h3>
        <p>
          {data?.description}
        </p>
        <div
          className={data?.status === "active" ? "active-badge" : "inactive-badge"}>
          {data?.status}
        </div>
        <div className="mt-3">
          <span>Category ID:</span>
          <h5>
            #{data?._id?.slice(-6)}
          </h5>
        </div>
      </div>
    </div>
  );
}

export default ViewCategory;